<template>
  <v-container>
    <div class="_fs-36 mt-8 mt-md-4">
      สิทธิพิเศษ
    </div>
    <div class="mt-4 _fs-20">
      สำหรับลูกค้าทุกประเภทที่เข้ามาใช้บริการ LINE DIY (New, Transfer, Existing และ Re-activated)
    </div>

    <v-row class="mt-8">
      <v-col
        cols="12"
        md="4"
        class="d-flex justify-center align-center d-md-block"
      >
        <a
          href="https://s3.ap-southeast-1.amazonaws.com/linediy-production.photo/files/professional-line-usage.pdf"
          target="_blank"
          download
        >
          <v-card
            elevation="0"
            height="310"
            width="310"
            class="rounded-xl"
          >
            <img
              src="/img/privilege/professional-line-usage.png"
              alt="professional-line-usage"
              width="100%"
              height="100%"
            >
          </v-card>
        </a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Privilege'
}
</script>
